import "../styles/Main.css";
import EnvForm from "../components/EnvForm";
import "bootstrap/dist/css/bootstrap.min.css";

function Main() {
	return (
		<div className="Main">
			<EnvForm />
		</div>
	);
}

export default Main;
